import Empresas from "./Empresas";
export default Empresas;